<h3 mat-dialog-title>
    {{titulo}}
</h3>

<div mat-dialog-content>

    <div fxLayout="row wrap">
        
        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>Status Migração</mat-label>
                <mat-select 
                    [(value)]="model.status_migracacao_id" 
                    [formControl]="status_migracacao_id"
                    name="status_migracacao_id">
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option 
                        *ngFor="let status of listStatus" 
                        [value]="status.id"
                    >
                    {{status.nome}}
                </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxFlex.gt-sm="100%">
            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>Verificado</mat-label>
                <mat-select 
                    [(value)]="model.verificado_migracao" 
                    [formControl]="verificado_migracao"
                    name="verificado_migracao">
                    <mat-option value="false">NÃO</mat-option>
                    <mat-option value="true">SIM</mat-option>                    
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    
</div>

<div mat-dialog-actions>

    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()"
        tabindex="-1"
    >
        Salvar
    </button>
</div>